import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mdl-filter-goals',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './mdl-filter-goals.html',
  styleUrl: './mdl-filter-goals.css' 
})
export class MdlFilterGoals {
  constructor(
    public mdl: MatDialogRef<MdlFilterGoals>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.filters = { ...this.filters, ...data };
    }
  }
  

  filters = {
    allStatuses: true,
    allFavorites: true,
    progressRange: 'all',
    dateRange: 'all',
    statuses: {
      sinIniciar: false,
      enCurso: false,
      incompleto: false,
      completado: false
    },
    favorites: {
      marcadas: false,
      noMarcadas: false
    }
  };

  statusTypes: Array<keyof typeof this.filters.statuses> = [
    'sinIniciar',
    'enCurso',
    'incompleto',
    'completado'
  ];

  favoriteTypes: Array<keyof typeof this.filters.favorites> = [
    'marcadas',
    'noMarcadas'
  ];

  toggleAllStatuses() {
    if (this.filters.allStatuses) {
      for (const key of this.statusTypes) {
        this.filters.statuses[key] = true;
      }
    } else {
      for (const key of this.statusTypes) {
        this.filters.statuses[key] = false;
      }
    }
  }

  onStatusChange() {
    const allStatusesSelected = this.statusTypes.every(key => this.filters.statuses[key]);
    const anyStatusSelected = this.statusTypes.some(key => this.filters.statuses[key]);
    
    this.filters.allStatuses = allStatusesSelected;
    
    if (!anyStatusSelected) {
      this.filters.allStatuses = true;
      this.toggleAllStatuses();
    }
  }

  toggleAllFavorites() {
    if (this.filters.allFavorites) {
      for (const key of this.favoriteTypes) {
        this.filters.favorites[key] = true;
      }
    } else {
      for (const key of this.favoriteTypes) {
        this.filters.favorites[key] = false;
      }
    }
  }

  onFavoriteChange() {
    const allFavoritesSelected = this.favoriteTypes.every(key => this.filters.favorites[key]);
    const anyFavoriteSelected = this.favoriteTypes.some(key => this.filters.favorites[key]);
    
    this.filters.allFavorites = allFavoritesSelected;
    
    if (!anyFavoriteSelected) {
      this.filters.allFavorites = true;
      this.toggleAllFavorites();
    }
  }

  closeMdl() {
    this.mdl.close();
  }

  applyFilters() {
    this.mdl.close(this.filters);
  }
}